/** Backend refusals as the customer should read them; anything else falls back to the backend's own message. */
const MESSAGES: Record<string, string> = {
  CUSTOMER_DETAILS_INCOMPLETE: 'Please complete your details before uploading a statement.',
  CUSTOMER_DETAILS_LOCKED: 'Your details can no longer be changed for this application.',
  INVALID_BVN: 'Your BVN must be 11 digits.',
  INVALID_NIN: 'Your NIN must be 11 digits.',
  INVALID_EMAIL: 'Please enter a valid email address.',
  INVALID_DATE_OF_BIRTH: 'Please enter a valid date of birth.',
  INVALID_STATEMENT: 'Please upload your bank statement as a PDF.',
  INVALID_BANK_CODE: 'Please choose the bank that issued the statement.',
  STATEMENT_TOO_LARGE: 'The statement must be 10MB or smaller.',
  DUPLICATE_STATEMENT: 'You have already uploaded this statement. Please upload a different one.',
  STATEMENT_BEING_ANALYSED: 'Your statement is still being reviewed.',
  STATEMENT_ALREADY_ANALYSED: 'Your statement has already been reviewed.',
  STATEMENT_LOCKED: 'A statement can no longer be uploaded for this application.',
  STATEMENT_NOT_STORED: 'We could not save your statement. Please try again shortly.',
  OFFER_NOT_AVAILABLE: 'There is no offer to show yet.',
  OFFER_EXPIRED: 'This offer has expired. Please start again from the checkout.',
  OFFER_DECIDED: 'You have already responded to this offer.',
};

export interface ApiError {
  code?: string;
  status?: number;
  message: string;
}

export const toApiError = (error: any): ApiError => {
  const status: number | undefined = error?.response?.status;
  const data = error?.response?.data ?? {};
  // The backend returns the serialised exception: its code is reasonCodeStr.
  const code: string | undefined = data.reasonCodeStr ?? data.reasonCode ?? data.code;
  if (status === 401 || status === 404) {
    return { code, status, message: 'This session has expired. Close this window and start again from the checkout.' };
  }
  if (!error?.response) {
    return { status, message: 'We could not reach Ceviant. Check your connection and try again.' };
  }
  return { code, status, message: (code && MESSAGES[code]) || data.message || 'Something went wrong. Please try again.' };
};

export const isSessionExpired = (error: ApiError | null | undefined) => error?.status === 401 || error?.status === 404;
